<div class="html-editor">
  <ngx-codemirror
    id="codemirrorHtmlEditor"
    [(ngModel)]="editorService.presentation.layout"
    [options]="codemirrorOptions"
  ></ngx-codemirror>
</div>
